import { render } from "./InputSlider.vue?vue&type=template&id=72ca1f26"
import script from "./InputSlider.vue?vue&type=script&lang=js"
export * from "./InputSlider.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__